import classnames from 'classnames';
import type { CSSProperties } from 'react';
import styled from 'styled-components';

import { tabletAndAbove } from '#src/style/mediaQuery.ts';

import blDesktop from './assets/bl-desktop.webp';
import blMobile from './assets/bl-mobile.webp';

type Props = {
  overlayStartColor?: string;
  overlayMidColor: string;
  overlayEndColor?: string;
  className?: string;
  contained?: boolean;
};

const Root = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
  isolation: isolate;
  z-index: -1;
  overflow: hidden;
  --bg-height: var(--100vh);
  --overlay-mid-stop: 44vh;

  &.contained {
    --bg-height: 100%;
    --overlay-mid-stop: 44%;
  }
`;

const GradientLayer = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to bottom,
    var(--overlay-start),
    var(--overlay-mid) var(--overlay-mid-stop),
    var(--overlay-end) var(--bg-height)
  );
`;

const ImageLayerOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: var(--bg-height);
  background: linear-gradient(to top, var(--overlay-end) 0, transparent 50px);
`;

const ImageLayer = styled.div`
  position: absolute;
  inset: 0;
  --bg-image: url(${blMobile});
  background-image: var(--bg-image);
  background-size: 100% var(--bg-height);
  background-position: center top;
  background-repeat: no-repeat;
  mix-blend-mode: screen;

  @media ${tabletAndAbove} {
    --bg-image: url(${blDesktop});
  }

  &.contained {
    --bg-image: url(${blDesktop});
    background-size: 100% auto;
  }
`;

export const SecondaryPageBackground = ({
  overlayStartColor = 'var(--c-black)',
  overlayMidColor,
  overlayEndColor = 'var(--c-dark-primary)',
  className,
  contained,
}: Props) => (
  <Root
    style={
      {
        '--overlay-start': overlayStartColor,
        '--overlay-mid': overlayMidColor,
        '--overlay-end': overlayEndColor,
      } as CSSProperties
    }
    className={classnames(className, { contained })}
    aria-hidden
  >
    <GradientLayer />
    <ImageLayer className={classnames({ contained })} />
    <ImageLayerOverlay />
  </Root>
);
